import { Typography } from '@mui/material';
import CopyrightIcon from '@mui/icons-material/Copyright';
import EmailIcon from '@mui/icons-material/Email';
import { Trans } from 'react-i18next';

const Footer = (): JSX.Element => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        <CopyrightIcon />
        <Typography variant={'subtitle2'}>
          &nbsp;{new Date().getFullYear()}{' '}
          <Trans>WZL | RWTH Aachen University</Trans>
        </Typography>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        <EmailIcon />
        <Typography variant={'subtitle2'}>
          &nbsp;Matthias Bodenbenner (
          <a href="mailto:m.bodenbenner@wzl-mq.rwth-aachen.de">matthias.bodenbenner@wzl-iqs.rwth-aachen.de</a>)
        </Typography>
      </div>
    </>
  );
};

export default Footer;
